/*----------------------------------------------------------------------------
|
|    Order Analysis (Item)
|
|    component to render order item analysis data
|
|    written by Alok Upendra Kamat
|    June 2026
|
\---------------------------------------------------------------------------*/

import React from 'react';

import { fmDateTime } from '../common/formatter.jsx';
import { SimpleDataGrid, BasicAlert } from '../common/components.jsx';

export class IOrderAnalysis extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var iRows = [];
    var orderAnalysis = this.props.orderAnalysis;
    var caller = this.props.caller || "osv";

    orderAnalysis.forEach(row => {
      switch (row[1]) {
        case "I":
          iRows.push(row);
          break;
      }
    });

    if (iRows.length > 0) {
      var itemAnalysisData = {
        header: [
          { name: DD('item_subitem', caller) },
          { name: DD('analysis_outlier_type', caller) },
          { name: DD('analysis_outlier_risk_level', caller) },
          { name: DD('analysis_details', caller), wrap: '1' },
          { name: DD('analysis_suggestion', caller), wrap: '1' },
          { name: DD('analysis_timestamp', caller) }
        ],
        data: iRows.map(function (row) {
          return [
            row[2],
            row[9],
            row[10],
            row[11],
            row[12],
            fmDateTime(row[3])
          ]
        })
      }

      return (
        <div>
          <SimpleDataGrid leftLabel="Item Analysis"
                          header={itemAnalysisData.header}
                          data={itemAnalysisData.data}
                          stretchTo="#globalFooter" stretchMargin="10" />
        </div>
      )

    } else {
      return (
        <BasicAlert type="N" />
      )
    }
  }
}
